/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Transcript_ExportInputs */



/**
* | output |
* | --- |
* | "Transcript Export (.txt, .docx, .csv)" |
*
* @param {Signup_Compare_Transcript_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_transcript_export = /** @type {((inputs?: Signup_Compare_Transcript_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Transcript_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcript Export (.txt, .docx, .csv)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transcript Export (.txt, .docx, .csv)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Transcript Export (.txt, .docx, .csv)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Transcript Export (.txt, .docx, .csv)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcript Export (.txt, .docx, .csv)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Transcript Export (.txt, .docx, .csv)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Transcript Export (.txt, .docx, .csv)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Transcript Export (.txt, .docx, .csv)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcript Export (.txt, .docx, .csv)")
	return /** @type {LocalizedString} */ ("Transcript Export (.txt, .docx, .csv)")
});